import React, { Component } from 'react';
import './authentication.css';
import logoImage from '../../resources/images/autofact-logo-new.svg';
import { FormGroup, ControlLabel, FormControl, Grid, Row, Col, Image } from 'react-bootstrap';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import AutoDismissAlert from '../../components/auto_dismiss_alert/AutoDismissAlert';
import { withRouter } from 'react-router-dom';
import { setCode } from "../../redux/actionCreators";
import { connect } from "react-redux";

class Authentication extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            alertSuccess: null,
            aletError: null,
        }
    }

    doLogin = (event) => {
        event.preventDefault();
        const password = this.state.password.trim();
        if (!/^\d{4}$/.test(password)) {
            if (password.length === 0) {
                this.setAlert('warning', 'Debes ingresar la clave diaria para continuar.');
            }else{
                this.setAlert('danger', 'La clave debe contener 4 dígitos. Verifica e intenta nuevamente.');
            }
            return;
        }
        const code = this.props.code;
        this.props.login(code, password);
    };


    setAlert = (type, message) => {
        if(type == 'success'){
            this.setState({
                alertSuccess: {
                    type: type,
                    message: message
                }
            });
        }
        if(type == 'danger' || type == 'warning'){
            this.setState({
                aletError: {
                    type: type,
                    message: message
                }
            });
        }
    }        
        
    handleAlertClose = () => {
        this.setState({
            alertSuccess: null,
            aletError: null
        });
    }

    getImage = () => {
        let result = <Image src={logoImage} className='autofact-logo' />;
        if (this.props.companyLogo) {
            result = (
                <div className='content-logo'>
                    <div className='top-logo'>
                        <Image src={this.props.companyLogo} />
                    </div>
                </div>
            );

        }
        return result;
    }

    getDescriptionContent = () => {
        if (this.props.passwordType === 'PROCESS_PASSWORD') {
            return (
                <p className={'welcome-description'}>
                    Para acceder al sistema debe ingresar la <strong>clave</strong> indicada en el correo enviado con asunto <b>"Documentos a Firmar".</b>
                </p>
            );
        } else {
            return (
                <p className={'welcome-description'}>
                    Para acceder al sistema, por favor ingresa la <strong>clave diaria</strong> que ha sido enviada hoy a tu teléfono mediante un mensaje SMS.
                </p>
            );
        }
    };

    getWelcomeLabel = () => {
        if (this.props.passwordType === 'PROCESS_PASSWORD') {
            return (
                <ControlLabel className={'welcome-label'}>
                   Ingrese la clave del proceso para acceder
                </ControlLabel>
            );
        } else {
            return (
                <ControlLabel className={'welcome-label'}>
                    Ingresa tu clave diara para acceder
                </ControlLabel>
            );
        }
    };

    render() {
        return (
        <div className={'authentication page-layout'}>
            <PageWithFooter
                footer={(
                    <FooterContainer>
                        <MainButton
                            text={'Ingresar'}
                            className={'next-button'}
                            onClick={this.doLogin}
                        />
                    </FooterContainer>
                )}
            >
            <Grid className='authentication-container'>
                    <Row className={'image-content'}>
                        <Col xs={12}>
                            {this.getImage()}
                        </Col>
                    </Row>
                    <Row>
                        <div className='form' >
                            <p className='welcome-title'>Te damos la bienvenida</p>
                            {this.getDescriptionContent()}
                            <FormGroup className={'input-content'}>
                                {this.getWelcomeLabel()}
                                <FormControl
                                    className={'code-input'}
                                    type={'password'}
                                    name={'password'}
                                    placeholder={'Clave'}
                                    value={this.state.password}
                                    onChange={(event) => this.setState({ password: event.target.value })}
                                />
                            </FormGroup>
                            { this.state.aletError &&
                                <AutoDismissAlert
                                    type={this.state.aletError.type}
                                    message={this.state.aletError.message}
                                    onClose={this.handleAlertClose}                                    
                                />
                            }
                        </div>
                    </Row>
            </Grid>
            </PageWithFooter>
        </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        code: state.code,
        passwordType: state.passwordType,
        companyLogo: state.companyLogo,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setCode(code) {
            dispatch(setCode(code));
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authentication));
